import { t } from "i18next";

import { logger } from "@/services/config/mixpanel";
import { splitCamelCase } from "@/utils";

import styles from "./styles";
import { IButtonProps } from "./types";
import { BlinkDots } from "../BlinkDots";

export const Button = ({
  name,
  handler,
  type = "primary",
  color,
  disabled = false,
  iconLeft,
  iconRight,
  loading,
  additionalDataForName,
}: IButtonProps) => {
  const translate = t(`Actions.${name}`, { ...additionalDataForName });
  return (
    <styles.ButtonContainer
      onClick={() => {
        logger.trackEvent(splitCamelCase(name));
        handler();
      }}
      $type={type}
      $color={color}
      $loading={Boolean(loading)}
      disabled={disabled || loading}
    >
      {iconLeft && iconLeft}
      {loading ? <BlinkDots>{translate}</BlinkDots> : translate}
      {iconRight && iconRight}
    </styles.ButtonContainer>
  );
};
